import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { SetupInstance } from '../../app/msal-account-helpers';
import { useUserProfile } from '../../app';

import GraphAPI from '../../api/graph/graph-api';

// Map backend apiRoles (e.g. "tenant_Manager") to display roles
// consistent with menus (e.g. "Tenant.Manager")
const mapApiRoleToDisplayRole = apiRole => {
    const roleMap = {
        tenant_Manager: 'Tenant.Manager',
        user_Basic: 'User.Basic',
        billing_Admin: 'Billing.Admin',
        application_Developer: 'Application.Developer',
    };
    return roleMap[apiRole] || apiRole;
};

const GraphQuery = () => {

    let { instance, inProgress, accounts } = useMsal();
    const profile = useUserProfile();
    const [me, setMe] = useState(null);

    instance = SetupInstance(instance);

    const tableRows = me ? Object.entries(me).map(item => {
        let key = item[0];
        let value = item[1];

        return (
            <tr key={key}>
                <td>{key}</td>
                <td>{value}</td>
            </tr>
        );
    }) : <tr key={"key"}>
        <td>Loading...</td>
        <td>Loading...</td>
    </tr>;

    const apiRoles = profile?.systemProfile?.apiRoles || [];
    const appRoles = apiRoles.map(mapApiRoleToDisplayRole);

    const tableAppRoleRows = appRoles && appRoles.length ? appRoles.map((item, index) => {
        return (
            <tr key={`roleKey-${index}`}>
                <td>{index}</td>
                <td>{item}</td>
            </tr>
        );
    }) : <tr key={"key"}>
        <td>Loading...</td>
        <td>Loading...</td>
    </tr>;


    useEffect(() => {

        if (inProgress === InteractionStatus.None && !me) {
            const api = new GraphAPI(instance, inProgress, accounts, false);
            api.getMeDetails().then(meResult => {
                setMe(meResult);
            });
        }
    }, [instance, accounts, inProgress, me]);

    return (
        <>
            <div className="data-area-div">
                <p>
                    See below the details in your <strong> Me Graph response </strong>.
                </p>
                <div className="data-area-div">
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Claim</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>{tableRows}</tbody>
                    </Table>
                </div>
            </div>

            <div className="data-area-div">
                <p>
                    See below the details in your <strong> Application Roles </strong>.
                </p>
                <div className="data-area-div">
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Number</th>
                                <th>Role</th>
                            </tr>
                        </thead>
                        <tbody>{tableAppRoleRows}</tbody>
                    </Table>
                </div>
            </div>

        </>
    );
}

export default GraphQuery;